interface ChipProps {
  label: string | React.ReactNode;
  secondaryLabel?: string | number;
  isSelected?: boolean;
  onClick?: () => void;
  style?: React.CSSProperties;
  className?: string;
}

const Chip: React.FC<ChipProps> = ({
  label,
  secondaryLabel,
  isSelected = false,
  onClick,
  style,
  className = "",
}) => {
  return (
    <button
      onClick={onClick}
      className={`chip ${
        isSelected ? "chip-selected" : "chip-unselected"
      } ${className}`}
      style={{ ...style, marginRight: "0.6rem" }} // Add horizontal space
    >
      <span style={{ color: style?.color || "inherit" }}>{label}</span>
      {secondaryLabel && (
        <span
          style={{
            color: style?.color || "inherit",
            marginLeft: "0.5rem",
            fontSize: "0.875rem",
          }}
        >
          ({secondaryLabel})
        </span>
      )}
    </button>
  );
};

export default Chip;
